import { MapPin, Phone, Clock, Car, Navigation } from "lucide-react";

const MAP_LINK = "https://maps.app.goo.gl/HqfGLzEKaHFjssbT7";
const MAP_EMBED =
  "https://www.google.com/maps?q=Nidan+Diagnostic+Centre+Laxmi+Plaza+Kesnand+Road+Wagholi+Pune&output=embed";

export default function VisitUs() {
  return (
    <section
      id="visit-us"
      data-testid="visit-us-section"
      className="py-20 lg:py-28 bg-[#f8fafc]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0099CC]">
            Visit Us
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Conveniently Located in the <span className="text-[#0099CC]">Heart of Wagholi</span>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Easy access from Kharadi, Lohegaon, Kesnand and nearby Pune areas, with ample
            parking right outside the building.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="bg-white rounded-3xl border border-slate-100 shadow-[0_8px_30px_rgba(15,23,42,0.04)] overflow-hidden">
              <div className="p-6 sm:p-8 space-y-5">
                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-2xl bg-[#00BFFF]/10 text-[#0099CC] flex items-center justify-center shrink-0">
                    <MapPin className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold tracking-wider text-slate-500 uppercase">Address</p>
                    <p className="mt-1 text-base font-semibold text-slate-900 leading-snug">
                      Office No. 103, First Floor, Laxmi Plaza, Rudra Complex, Kesnand Road,
                      Wagholi, Pune
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-2xl bg-[#00BFFF]/10 text-[#0099CC] flex items-center justify-center shrink-0">
                    <Phone className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold tracking-wider text-slate-500 uppercase">Phone</p>
                    <a
                      href="tel:+918854865454"
                      className="mt-1 block text-base font-semibold text-slate-900 hover:text-[#0099CC]"
                      data-testid="visit-phone"
                    >
                      8854865454
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-2xl bg-[#00BFFF]/10 text-[#0099CC] flex items-center justify-center shrink-0">
                    <Clock className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold tracking-wider text-slate-500 uppercase">Timings</p>
                    <p className="mt-1 text-base font-semibold text-slate-900 leading-snug">
                      Mon – Sat &middot; 10:00 AM – 9:00 PM
                    </p>
                    <p className="text-sm text-slate-500">Sunday: by appointment</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 rounded-2xl bg-[#00BFFF]/10 text-[#0099CC] flex items-center justify-center shrink-0">
                    <Car className="w-5 h-5" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold tracking-wider text-slate-500 uppercase">Parking</p>
                    <p className="mt-1 text-base font-semibold text-slate-900 leading-snug">
                      Ample parking available outside Rudra Complex.
                    </p>
                  </div>
                </div>
              </div>

              <a
                href={MAP_LINK}
                target="_blank"
                rel="noreferrer"
                data-testid="get-directions-btn"
                className="flex items-center justify-center gap-2 bg-[#00BFFF] hover:bg-[#0099CC] text-white font-semibold py-4 transition-all"
              >
                <Navigation className="w-5 h-5" />
                Get Directions
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-3xl overflow-hidden border border-slate-100 shadow-[0_8px_30px_rgba(15,23,42,0.04)] h-[420px] sm:h-[480px] bg-white">
              <iframe
                title="Nidan Diagnostic Centre — Wagholi Location"
                src={MAP_EMBED}
                width="100%"
                height="100%"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                data-testid="map-embed"
                className="border-0 w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
